import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import {ReceiptLongOutlined, StorefrontOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

const METRICS = [{title: "TotalOrders", icon: ReceiptLongOutlined}, {title: "TotalDistributors", icon: StorefrontOutlined}];

export default function TabOverview({tabValue}) {
    const {t} = useTranslation();
    return <div role="tabpanel" hidden={tabValue !== 0} id="pharmacy-tabpanel-0" aria-labelledby="pharmacy-tab-0">
        {tabValue === 0 && <>
            <Typography variant="h6" sx={{mb: 2}}>{t("KeyMetrics")}</Typography>
            <Grid container spacing={2}>
                {METRICS.map(({title, icon: Icon}) => <Grid item xs={12} sm={6} key={title}>
                    <Card variant="outlined" sx={{height: "100%", borderRadius: 2}}><CardContent>
                        <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
                            <Typography variant="body2" color="text.secondary">{t(title)}</Typography>
                            <Icon sx={{color: "primary.main", fontSize: 22, flexShrink: 0}}/>
                        </Box>
                        <Typography variant="h4" sx={{my: 1}}>—</Typography>
                        <Typography variant="body2" color="text.secondary">{t("DistributorMetricUnavailable")}</Typography>
                    </CardContent></Card>
                </Grid>)}
            </Grid>
        </>}
    </div>;
}
